var _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMusic = function SvgIconMusic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.262 9.844V2.729c0-.738-.711-1.267-1.418-1.055L5.702 3.216c-.466.14-.785.569-.785 1.056v6.525M4.917 6.39l7.345-2.204",
    stroke: "#A4A7AD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.203,
    cy: 10.796,
    r: 1.703,
    stroke: "#A4A7AD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.553,
    cy: 9.797,
    r: 1.703,
    stroke: "#A4A7AD"
  })));
};
export default SvgIconMusic;